import { mutator } from 'satcheljs';
import { onLoadingSet } from '../actions';
import { getLoginPageStore } from '..';

mutator(onLoadingSet, (msg) => {
  getLoginPageStore().loading = msg.value;
});
